<template>
  <v-layout justify-end pr-3>
    <v-tooltip left>
      <div slot="activator">
        <v-btn
          icon
          small
          color="theme_primary"
          depressed
          :disabled="documents.length === 0"
          @click="dialog = true"
        >
          <v-badge overlap right bottom :value="documents.length">
            <v-icon size="20">assignment</v-icon>
            <span slot="badge" v-if="documents.length > 0">
              {{ documents.length }}
            </span>
          </v-badge>
        </v-btn>
      </div>
      <span>{{ title }}</span>
    </v-tooltip>

    <v-dialog
      lazy
      v-model="dialog"
      max-width="1024"
      :fullscreen="
        this.$vuetify.breakpoint.md ||
        this.$vuetify.breakpoint.sm ||
        this.$vuetify.breakpoint.xs
      "
    >
      <v-card>
        <v-toolbar
          tile
          card
          flat
          height="36"
          color="theme_primary"
          class="white--text"
        >
          <v-toolbar-side-icon>
            <v-icon small color="white">assignment</v-icon>
          </v-toolbar-side-icon>
          <v-spacer></v-spacer>
          <v-toolbar-title class="white-text text-capitalize subheading">
            {{ title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-layout row grow>
            <v-flex xs12 sm12 md6 lg5 xl4 pa4>
              <template v-for="(file, index) in documents">
                <v-flex xs12 pa0 :key="'doc_' + index">
                  <v-list dense two-line subheader>
                    <v-list-tile
                      :class="{ fileList: selectedFile == index }"
                      avatar
                      @click="clicOnListItem(index)"
                    >
                      <v-list-tile-avatar>
                        <v-icon
                          color="white"
                          :class="
                            fileIconColor(file.url) + ' lighten-1 white--text'
                          "
                          >{{ fileIcon(file.url) }}</v-icon
                        >
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="body-1">
                          {{ file.name }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <a
                            class="caption"
                            :href="`${s3bucket}/${file.url}`"
                            download
                            >{{ file.url }}</a
                          >
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </template>
            </v-flex>
            <v-divider vertical></v-divider>

            <v-flex
              xs12
              sm12
              md6
              lg7
              xl8
              style="height: inherit;"
              v-if="documents.length > 0"
            >
              <filePreviewer
                :filename="selectedFileUrl"
                :url="s3bucket + '/' + selectedFileUrl"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" flat color="red">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import files from "../../mixins/files.js";
import filePreviewer from "../../components/shared/filePreviewer";
export default {
  name: "availableDocuments",
  components: {
    filePreviewer,
  },
  mixins: [files],
  props: {
    title: {
      type: String,
      required: false,
      default: "Available documents",
    },
    documents: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedFile: 0,
      dialog: false,
    };
  },
  computed: {
    selectedFileUrl() {
      let ret = this.documents[this.selectedFile];
      return ret ? ret.url : "";
    },
  },
  methods: {
    clicOnListItem(index) {
      this.selectedFile = index;
    },
  },
};
</script>
<style>
.fileIconBtn {
  height: 64px !important;
  width: 64px !important;
}

.fileList {
  background-color: #eeeeee !important;
}

.uploadList {
  background-color: #f4f4f4 !important;
}

.uploadList .v-list__tile {
  height: min-content !important;
}
</style>
